import { render, staticRenderFns } from "./ApplicantIndex.vue?vue&type=template&id=0fa6b12b&scoped=true&"
import script from "../../services/applicant/applicant-index.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-index.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/profile.css?vue&type=style&index=0&id=0fa6b12b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6b12b",
  null
  
)

export default component.exports